import { render, staticRenderFns } from "./loading2.vue?vue&type=template&id=c8d0fd62&scoped=true&"
import script from "./loading2.vue?vue&type=script&lang=js&"
export * from "./loading2.vue?vue&type=script&lang=js&"
import style0 from "./loading2.scss?vue&type=style&index=0&id=c8d0fd62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0fd62",
  null
  
)

export default component.exports